import { render, staticRenderFns } from "./saveViewTemplate.vue?vue&type=template&id=f2356fc0"
import script from "./saveViewTemplate.vue?vue&type=script&lang=js"
export * from "./saveViewTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports